// Private method that returns a flat JSON lookup table
// to be used by the rest of our OpenX implementation.
// Also, more words.

function expandRange(result) {
  if (!result) {
    return {};
  }
  if (result === '*') {
    return result;
  }

  // Map position ranges to separated items
  Object.keys(result).forEach((position) => {
    // We don't need to process normal numbers
    if (position.indexOf('...') === -1 && position.indexOf('-') === -1) {
      return;
    }

    // Determine the range
    const range = position.split(/(\.\.\.|-)/);
    const start = parseInt(range[0], 10);
    const end = parseInt(range[2], 10);

    // Validate the range
    if (start < 1) {
      throw 'RangeStartOutOfBounds';
    }
    if (end <= start) {
      throw 'RangeEndOutOfBounds';
    }

    // Map everything in this range
    // NOTE: This does not map duplicates and WILL overwrite
    // specific ones if they overlap. Don't make them overlap.
    for (let j = start; j <= end; j++) {
      result[j] = result[position];
    }

    // Clear this position
    result[position] = null;
    delete result[position];
  });

  return result;
}

export default function flatten(input = []) {
  return input.map((region) => {
    // Do we need to set a default position?
    if ('defaultPosition' in region) {
      region.positions['*'] = region.defaultPosition;
    }

    region.positions = expandRange(region.positions);
    region.timers = expandRange(region.timers);

    // Return this flattened region
    return region;
  });
}
